import React, { Component } from 'react';
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBIcon, MDBRow, MDBCol } from 'mdbreact';
import axios from 'axios';
import ConfigData from '../Components/config';
import AppDataTable from '../Components/AppDataTable';

export default class showcertificateHeadtabianhistory extends Component {

    constructor(props) {
        super(props)
        this.state = {
            countShowReportPetition: 0,
            array_ShowReportPetition: [],
        }
    }

    componentDidMount() {
        if (!(localStorage.getItem('token'))) {
            window.location.href = '/rubrongkpru'
        }
        axios.get(ConfigData.SERVER_URL + 'FrontEnd_Tabian/petition/ShowReportCertificatehistory/').then((ShowReportPetition) => {
            if (ShowReportPetition.data.length !== 0) {
                var i = 0;
                while (i < ShowReportPetition.data.length) {
                    ShowReportPetition.data[i]['Index'] = i + 1;
                    if (ShowReportPetition.data[i]['STATUS'] === '0') {
                        ShowReportPetition.data[i]['Statusfill'] = <button className="btn btn-danger btn-sm"><MDBIcon icon="ban" /> ไม่อนุญาตการขอใบรับรอง</button>
                    } else if (ShowReportPetition.data[i]['STATUS'] === '4') {
                        if (ShowReportPetition.data[i]['PRINT_STATUS'] === '1') {
                            ShowReportPetition.data[i]['Statusfill'] = <button className="btn btn-success btn-sm"><MDBIcon icon="check-circle" /> ใบรับรองเสร็จสมบูรณ์ </button>
                        } else {
                            ShowReportPetition.data[i]['Statusfill'] = <button className="btn btn-success btn-sm"><MDBIcon icon="check-circle" /> อนุมัติเอกสารเรียบร้อย </button>
                        }
                    }
                    i++;
                }
                this.setState({
                    array_ShowReportPetition: {
                        columns: [
                            { label: '#', field: 'Index', },
                            { label: 'วันที่ร้องขอ', field: 'DATE_INSERT', },
                            { label: 'รหัสนักศึกษา', field: 'OLDID', },
                            { label: 'ชื่อ-นามสกุล', field: 'NAME', },
                            { label: 'ขอใบรับรองเรื่อง', field: 'TYPEPITITION_NAME', },
                            { label: 'ภาษาไทย', field: 'NUM_RUBRONGTH', },
                            { label: 'ภาษาอังกฤษ', field: 'NUM_RUBRONGEN', },
                            { label: 'สถานะ', field: 'Statusfill', },
                        ],
                        rows: ShowReportPetition.data
                    }
                })
                this.setState({ countShowReportPetition: ShowReportPetition.data.length });
            }
        })
    }

    render() {
        return (<>
            <span className="white-text mt-3" style={{ fontSize: '22px' }}>ประวัติการขอเอกสารทางการศึกษา</span><span className="white-text mt-3" style={{ fontSize: '16px' }}> มหาวิทยาลัยราชภัฏกำแพงเพชร</span>

            <MDBRow>
                <MDBCol lg="12" md="12" sm="12">
                    <MDBCard className="mt-3">
                        <MDBCardBody>
                            <MDBCardTitle className="h5">
                                ประวัติการขอเอกสารทางการศึกษา
                            </MDBCardTitle>
                            <MDBCardText>
                                {this.state.countShowReportPetition === 0 ? <>
                                    <span className="text-danger">ไม่มีข้อมูลการขอเอกสารทางการศึกษา</span>
                                </> : <>
                                    <AppDataTable data={this.state.array_ShowReportPetition} />
                                </>}
                            </MDBCardText>
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>
        </>)
    }
}